import SuperFetch from 'library/helpers/superFetch';
import { useManagePermittedRoles } from 'library/hooks';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import { assetGroupActions } from 'reduxStore/assetGroups/slice';
import { Notification } from 'zComponents/atoms';
import { Button, Modal, Typography } from 'zui/Antd';
import { ConditionalTooltipButton } from 'zui/Custom';

const { Text } = Typography;

// Accepts props from parent: groupID, visible, setVisible
const DeleteAssetGroupModal = ({ children, groupID, visible, setVisible }) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	// treat groupID prop as the group object
	const group = groupID;

	// Permissions
	const isPermitted = useManagePermittedRoles('deleteGroup', {
		orgID: [group?.orgID],
		siteID: [group?.siteID],
		floorID: []
	});

	const handleCancel = () => setVisible(false);
	const handleDelete = () => {
		setLoading(true);
		SuperFetch.delete(`/deviceGroups/${group.groupID}`)
			.then((res) => {
				if (res.statusCode === 200) {
					Notification('success', `Deleted ${group?.name}`);
					dispatch(assetGroupActions.loadGroups());
					handleCancel();
				} else {
					Notification('error', 'Error deleting group');
				}
			})
			.catch(() => Notification('error', 'Something went wrong'))
			.finally(() => setLoading(false));
	};

	return (
		<Fragment>
			<ConditionalTooltipButton
				condition={isPermitted}
				falseTitle='Delete Asset Group'
				trueTitle="You don't have permission"
				disabledCondition={!isPermitted}
				onClick={() => setVisible(true)}
				danger
			>
				{children}
			</ConditionalTooltipButton>

			<Modal
				title='Delete a Group'
				open={visible}
				onCancel={handleCancel}
				destroyOnClose={true}
				danger
				footer={[
					<Button key='cancel' onClick={handleCancel}>
						Cancel
					</Button>,
					<Button key='delete' type='primary' danger loading={loading} onClick={handleDelete}>
						Delete
					</Button>
				]}
			>
				<Text>
					Are you sure you want to delete '<strong>{group?.name}</strong>'?
				</Text>
			</Modal>
		</Fragment>
	);
};

export default DeleteAssetGroupModal;
